import { apiKeys, apiRequest } from ".";

export const getConnectionOauthDefinitionApi = (type: string, linkHeaders?: Record<string, unknown>) => {
    return apiRequest({
      method: 'GET',
      url: `${apiKeys['connection.oauth.definition']}/view/${type}`,
      payload: {},
      withCredentials: linkHeaders?.["X-Pica-Use-Headers"] === "true"
    });
  };

export const createConnectionOauthStateApi = ({secretId, formData, connectionOauthDefinitionId, requestId, linkHeaders}: {secretId: string, formData: Record<string, unknown>, connectionOauthDefinitionId: number, requestId: number, linkHeaders?: Record<string, unknown>}) => {
  return apiRequest({
    method: "POST",
    url: apiKeys['connections.oauth'],
    payload: {
      secretId,
      formData,
      connOauthDefId: connectionOauthDefinitionId,
      requestId,
    },
    withCredentials: linkHeaders?.["X-Pica-Use-Headers"] === "true"
  })
}